import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface GAIAProductDetailsViewSupplementalFactsStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
    fullPrimaryImageModal?: ModalPresentationProps;
    image?: LazyImageProps;
}

export const viewSupplementalFactsStyles: GAIAProductDetailsViewSupplementalFactsStyles = {
    wrapper: {
        css: css`
            margin: 15px 0px;
            width: 100%;
        `,
    },
    link: {
        css: css`
            font-family: "LatoBold";
        `,
    },
    fullPrimaryImageModal: {
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                max-width: initial;
                max-height: initial !important;
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 10px 10px 0;
            `,
            modalContent: css`
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 30px 15px;
            `,
        },
    },
    image: {
        css: css`
            width: auto;
            max-height: 70vh;
            img {
                width: auto;
                max-height: 70vh;
            }
        `,
    },
};

const styles = viewSupplementalFactsStyles;

const GAIAProductDetailsViewSupplementalFacts: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    const [viewSupplementFactsIsOpen, setViewSupplementFactsIsOpen] = React.useState(false);

    const handleOpenModal = () => {
        setViewSupplementFactsIsOpen(true);
    };
    const handleCloseModal = () => {
        setViewSupplementFactsIsOpen(false);
    };
    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <Link {...styles.link} onClick={handleOpenModal}>
                    {translate("View Supplement Facts")}
                </Link>
            </StyledWrapper>
            <Modal isOpen={viewSupplementFactsIsOpen} handleClose={handleCloseModal} {...styles.fullPrimaryImageModal}>
                <LazyImage
                    src="/UserFiles/Images/ProductDetails/SupplementFacts.jpg?width=737&height=1000"
                    {...styles.image}
                />
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(GAIAProductDetailsViewSupplementalFacts)),
    definition: {
        displayName: "View Supplemental Facts Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
